import { useTheme } from '@mui/material';

import type { ScaleLinear } from 'd3-scale';
import type { FC } from 'react';
import type { Margin, YLabels } from 'shared/components/charts/types';

export type YScale = ScaleLinear<number, number, never>;

interface YAxisProps {
  margin: Pick<Margin, 'top'>;
  height: number;
  yScale: YScale;
  yLabels: YLabels;
  fontSize: number;
}

// TODO: refactor when will be more chart variants
const defaultWidth = 32;
const maxWidth = 72;

const getWidth = (yLabels: YLabels) =>
  yLabels.find(el => el.length > 4) ? maxWidth : defaultWidth;

export const YAxis: FC<YAxisProps> = ({
  height,
  margin,
  yScale,
  yLabels,
  fontSize = 12,
}) => {
  const theme = useTheme();

  return (
    <svg display="block" width={getWidth(yLabels)} height={height}>
      <g transform={`translate(${getWidth(yLabels)}, ${margin.top})`}>
        {yScale.ticks(yLabels.length).map((y, index) => (
          <text
            key={y}
            x={0}
            y={yScale(y) + fontSize / 2}
            dy={-1}
            fill={theme.palette.text.secondary}
            fontSize={fontSize}
            textAnchor="end"
          >
            {yLabels[index]}
          </text>
        ))}
      </g>
    </svg>
  );
};
